import { ReactElement } from 'react';
import { Typography } from '@weareopenr/component-library';
import { IBrandVenueAccess } from 'src/types';
import { venueAccessChoiceLabel } from './venueAccessLabels';
import styles from './UserModal.module.scss';

interface IAccessSummaryProps {
  isWildcard: boolean;
  brands: { id: string; name: string }[];
  venueAccess?: IBrandVenueAccess[];
  venueAccessEnabled?: boolean;
}

const isIncomplete = (entry?: IBrandVenueAccess): boolean =>
  !entry || (entry.access === 'specific' && (entry.venue_ids?.length ?? 0) === 0);

export const AccessSummary = ({
  isWildcard,
  brands,
  venueAccess,
  venueAccessEnabled = true,
}: IAccessSummaryProps): ReactElement => {
  const renderLines = (): ReactElement => {
    if (isWildcard) {
      return (
        <Typography size="small">
          {venueAccessEnabled ? 'All brands and venues' : 'All brands'}
        </Typography>
      );
    }

    if (brands.length === 0) {
      return (
        <Typography size="small" className={styles['summary-muted']}>
          Select brands to grant access.
        </Typography>
      );
    }

    return (
      <ul className={styles['summary-lines']}>
        {brands.map((brand) => {
          const entry = (venueAccess ?? []).find((candidate) => candidate.brand_id === brand.id);
          return (
            <li key={brand.id}>
              <Typography
                size="small"
                className={
                  venueAccessEnabled && isIncomplete(entry) ? styles['summary-muted'] : undefined
                }
              >
                {venueAccessEnabled
                  ? `${brand.name} — ${venueAccessChoiceLabel(entry)}`
                  : brand.name}
              </Typography>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <aside aria-label="Access summary" className={styles['summary-card']}>
      <Typography size="small" weight="semi-bold">
        This user can access
      </Typography>
      {renderLines()}
    </aside>
  );
};
